import { Tabs, TabsProps, Row, Col } from "antd";

import Container from "../../components/container";
import PageHeader from "../../components/PageHeader";
import OrganisationDetail from "./address.onboarding.new-workspace";
import { KycProvider } from "../kyc-verification/kyc/context/KycProvider";
import KycContainer from "../kyc-verification/kyc/components/KycContainer";

import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { useSearchParams } from "react-router";

const Workspace = () => {
  const user = useSelector((state: RootState) => state.user);
  const [searchParams] = useSearchParams();
  const paramTab = searchParams.get("tab");
  let tab = "1";
  if (paramTab === "2" || paramTab === "kyc") {
    tab = user?.is_verified ? "2" : "1";
  } else {
    tab = "1";
  }
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Organization Details",
      children: <OrganisationDetail />,
    },
    {
      key: "2",
      label: "Kyc & Bank Details",
      children: (
        <KycProvider>
          <KycContainer />
        </KycProvider>
      ),
    },
  ];
  return (
    <Container>
      <Row gutter={16} className="mt-6">
        <Col xs={24} lg={{ span: 12, offset: 6 }}>
          <PageHeader
            title="Page Settings"
            description="Manage the details of your page"
            backBtn={false}
          />
          <Tabs
            className={""}
            defaultActiveKey={tab === "2" ? "2" : "1"}
            items={items}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Workspace;
